import videojs from 'video.js'

export const createValidPreviewUrl = (url: string) => {
  // TODO: Remove the use of this when FBX-37 is resolved
  if (url.indexOf('hlspreview') > -1) return url.replace('http://', 'https://')
  const isSecure = url.indexOf('https://') > -1
  const _url = url.replace(isSecure ? 'https://' : 'http://', '').split('/')
  _url.splice(1, 0, 'hlspreview')
  return `https://${_url.join('/')}`
}

// Ignore specific VideoJS errors
export const overrideVideoJsErrorLogging = () => {
  const originalLogError = videojs.log.error
  videojs.log.error = (...args) => {
    const message = args[0]
    if (message && typeof message === 'string' && message.includes('MEDIA_ERR_SRC_NOT_SUPPORTED')) {
      // eslint-disable-next-line no-console
      console.warn('VIDEOJS: ', message)
      return
    }
    originalLogError(...args)
  }
}
